var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutPublic',{attrs:{"title":_vm.$t('login.title'),"subtitle":_vm.$t('login.unhcr.title')}},[_c('Loading',{attrs:{"loading":true,"size":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }